// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rtl[data-v-38acdab9]{direction:rtl}.ltr[data-v-38acdab9]{direction:ltr}.v-card[data-v-38acdab9]{-webkit-transition:all .3s;transition:all .3s}", ""]);
// Exports
module.exports = exports;
